<template>
  <fwa-record type="My FWA Record"></fwa-record>
</template>
    
<script>
import FwaRecord from "./FwaRecord.vue";
export default {
  components: {
    FwaRecord,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Fwa/MyFwaRecord.vue